import React, { useState } from "react";
import { api } from "@/lib/wolfApi";

export const NotifyForm = ({ testIdPrefix, productId = null, className = "" }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("sending");
    try {
      await api.post("/merch/notify", { email: email.trim(), product_id: productId });
      setStatus("done");
    } catch {
      setStatus("error");
    }
  };

  if (status === "done") {
    return (
      <p data-testid={`${testIdPrefix}-success`} className={`text-sm text-[#D4AF37] ${className}`}>
        You're on the list. First access when the store opens. 🐺
      </p>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`${testIdPrefix}-form`} className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testIdPrefix}-email-input`}
        className="flex-1 bg-[#0d0d0d] border border-white/15 focus:border-[#D4AF37] outline-none text-white text-sm px-4 py-3 placeholder:text-white/30 transition-colors"
      />
      <button
        type="submit"
        disabled={status === "sending"}
        data-testid={`${testIdPrefix}-submit-btn`}
        className="text-[11px] uppercase tracking-[0.28em] font-semibold text-black bg-[#D4AF37] hover:bg-[#F4C542] disabled:opacity-50 px-6 py-3 transition-all whitespace-nowrap"
      >
        {status === "sending" ? "…" : "Notify Me"}
      </button>
      {status === "error" && (
        <p data-testid={`${testIdPrefix}-error`} className="text-xs text-red-400/90 self-center">Something went wrong — try again.</p>
      )}
    </form>
  );
};
